import { DidYouMean as HeadlessDidYouMean } from '@coveo/headless';
import React from 'react';
import { useEffect, useState, FunctionComponent } from 'react';

interface DidYouMeanProps {
	controller: HeadlessDidYouMean;
}

export const DidYouMean: FunctionComponent< DidYouMeanProps > = ( props ) => {
	const { controller } = props;
	const [
		state,
		setState,
	] = useState( controller.state );

	useEffect( () => controller.subscribe( () => setState( controller.state ) ), [] );

	if ( ! state.hasQueryCorrection ) {
		return null;
	}

	if ( state.wasAutomaticallyCorrected ) {
		return (
			<div>
				<p>No results for { /* <b>{JSON.stringify(state.queryCorrection)}</b> */ }</p>
				<p>
					Query was automatically corrected to <b>{ state.wasCorrectedTo }</b>
				</p>
			</div>
		);
	}

	return (
		<button onClick={ () => controller.applyCorrection() }>
			<span className="has-kicker-variant">
				Did you mean: { state.queryCorrection.correctedQuery } ?
			</span>
		</button>
	);
};

// usage

/**
 * ```tsx
 * const controller = buildDidYouMean(engine);
 *
 * <DidYouMean controller={controller} />;
 * ```
 */
